import providersService from '@/services/providersService'

const state = {
  loadingProviders: true,
  providers: []
}

const mutations = {
  'SET_LOADING_PROVIDERS' (state, status) {
    state.loadingProviders = status
  },
  'SET_PROVIDERS' (state, providers) {
    state.providers = providers
  }
}

const actions = {
  getProviders (vuexContext) {
    vuexContext.commit('SET_LOADING_PROVIDERS', true)
    providersService.getProviders(vuexContext.getters.token)
      .then(response => {
        vuexContext.commit('SET_PROVIDERS', response.providers.rows)
        vuexContext.commit('SET_LOADING_PROVIDERS', false)
      })
      .catch((error) => {
        console.log(error)
        vuexContext.commit('SET_PROVIDERS', [])
        vuexContext.commit('SET_LOADING_PROVIDERS', false)
      })
  }
}

const getters = {

}

export default {
  state,
  mutations,
  actions,
  getters
}
